import React from "react";
import { Modal } from "react-bootstrap";
import ExamSummary from "../exam-summary/ExamSummary";
import ViewExamResultDetailsModalState, { ViewExamResultDetailsModalProps } from "./ViewExamResultDetailsModal.models";
import './ViewExamResultDetailsModal.scss';
import { NavLink } from "react-router-dom";
import { ExamTypes } from "../../../models/interfaces/exams/exam/ExamTypes";

export default class ViewExamResultDetailsModal extends React.PureComponent<ViewExamResultDetailsModalProps, ViewExamResultDetailsModalState>{

    constructor(props: ViewExamResultDetailsModalProps) {
        super(props);
        this.state = { examResultId: 0, showModal: false };
    }

    openModal = (examResultId: number, examType?: ExamTypes, examId?: number) => {
        this.setState({ showModal: true, examResultId: examResultId, examType, examId});
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    checkExamResult = () => {
        window.location.href = `/AnswerSheet?examResultId=${this.state.examResultId}`;
    }

    render(): React.ReactNode {
        let { examResultId, showModal, examType, examId} = this.state;
        return (<>
            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>اطلاعات آزمون</label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="view-exam-result-details-modal">
                    <ExamSummary showOptions={false} examResultId={examResultId} />
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    {
                        (examType == ExamTypes.ProficiencyTest || examType == ExamTypes.ExhaustiveTest) &&
                        <NavLink to={`/ExamReport?examId=${examId}&examResultId=${examResultId}`}>
                            <button className="btn btn btn-success" >
                                مشاهده کارنامه
                            </button>
                        </NavLink>
                    }
                    <button onClick={this.checkExamResult} className="btn btn btn-primary" >
                        مشاهده پاسخ برگ
                    </button>
                    <button className="btn btn btn-outline-primary tk-float-left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
    }
}